// Department chip picker shared by CRM scope chips and HR filters.
// Rows come from a <script type="application/json"> tree: [{id,name,depth,count}].
import { peopleIndex, closePeoplePicker } from './people-picker.js';
import { closeDatePicker } from './datepicker.js';

let openEl = null;
export function closeDeptPicker() { if (openEl) { openEl.remove(); openEl = null; } }
document.addEventListener('mousedown', (e) => { if (openEl && !openEl.contains(e.target)) closeDeptPicker(); }, true);
// Escape 는 문서 캡처에서 잡는다 (people-picker.js 와 같은 규칙). 팝 안에 포커스가
// 없어도 닫히고, stopImmediatePropagation 이 뒤의 사이드 패널·모달이 같은 Escape 로
// 함께 닫히는 것을 막는다 — .prop-pop 은 hr-panel.js 의 Escape 예외 목록에 이미 있다.
document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && openEl) { closeDeptPicker(); e.stopImmediatePropagation(); } }, true);

export function openDeptPicker(anchor, opts) {
    closeDeptPicker();
    // 다른 팝오버가 열려 있으면 먼저 닫는다 (crm.js 가 closeCrmPop() 으로 하던 일).
    closePeoplePicker();
    closeDatePicker();
    const { tree = [], current = '', onPick } = opts;
    const L = Object.assign({ filter: '부서', all: '전체', empty: '검색 결과 없음' }, opts.labels || {});
    const mobile = window.matchMedia && window.matchMedia('(max-width: 600px)').matches;
    const pop = document.createElement('div'); pop.className = 'prop-pop crm-dept-pop'; pop.setAttribute('role', 'listbox');
    let root = pop;
    if (mobile) { root = document.createElement('div'); root.className = 'pp-sheet-root'; pop.classList.add('cal-sheet', 'pp-sheet'); root.appendChild(pop); root.addEventListener('mousedown', (e) => { if (e.target === root) closeDeptPicker(); }); }
    const head = document.createElement('div'); head.className = 'prop-pop-head'; const input = document.createElement('input'); input.type = 'text'; input.placeholder = L.filter; head.appendChild(input); pop.appendChild(head);
    const listEl = document.createElement('div'); listEl.className = 'prop-pop-list'; pop.appendChild(listEl);
    const myDept = peopleIndex().meDept || '';
    const pick = (id) => { closeDeptPicker(); onPick(id); };
    function render(q) {
        listEl.innerHTML = '';
        const all = document.createElement('button'); all.type = 'button'; all.className = 'prop-pop-item none' + (!current ? ' sel' : ''); all.textContent = L.all; all.addEventListener('click', () => pick('')); listEl.appendChild(all);
        const ql = (q || '').trim().toLowerCase();
        tree.forEach((d) => {
            if (ql && !d.name.toLowerCase().includes(ql)) return;
            const b = document.createElement('button'); b.type = 'button'; b.className = 'prop-pop-item crm-dept-item' + (d.id === current ? ' sel' : '') + (d.id === myDept ? ' me' : ''); b.style.paddingLeft = (8 + (ql ? 0 : d.depth) * 14) + 'px'; b.dataset.id = d.id;
            const n = document.createElement('span'); n.className = 'crm-dept-name'; n.textContent = d.name; b.appendChild(n);
            const c = document.createElement('small'); c.className = 'text-muted'; c.textContent = d.count ? String(d.count) : ''; b.appendChild(c);
            if (d.id === current) { const ck = document.createElement('span'); ck.className = 'prop-pop-check'; ck.textContent = '✓'; b.appendChild(ck); }
            b.addEventListener('click', () => pick(d.id));
            listEl.appendChild(b);
        });
        if (listEl.children.length === 1 && ql) { const e = document.createElement('div'); e.className = 'prop-pop-empty'; e.textContent = L.empty; listEl.appendChild(e); }
    }
    render('');
    input.addEventListener('input', () => render(input.value));
    pop.addEventListener('keydown', (e) => {
        const items = Array.from(listEl.querySelectorAll('.prop-pop-item'));
        const i = items.indexOf(document.activeElement);
        if (e.key === 'ArrowDown') { e.preventDefault(); (items[i + 1] || items[0]).focus(); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); (items[i - 1] || input).focus(); }
        else if (e.key === 'Enter' && e.target === input) { e.preventDefault(); const first = listEl.querySelector('.crm-dept-item'); if (first) first.click(); }
        // Escape 는 여기 오지 않는다 — 위의 문서 캡처 리스너가 먼저 닫고
        // stopImmediatePropagation 으로 끊는다.
    });
    document.body.appendChild(root);
    if (!mobile) {
        const r = anchor.getBoundingClientRect();
        const w = pop.offsetWidth, h = pop.offsetHeight;
        const left = Math.min(Math.max(8, r.left), window.innerWidth - w - 8);
        let top = r.bottom + 4;
        if (top + h > window.innerHeight - 8) top = Math.max(8, r.top - h - 4);
        pop.style.left = left + 'px'; pop.style.top = top + 'px';
    }
    openEl = root;
    input.focus();
    return root;
}
